import React from 'react';
import { configurationsPiletModals } from '@sharefiledev/configurations-pilet-sdk';
import { OverlayModalComponentProps, PiletApi } from '@sharefiledev/sharefile-appshell';
import { EditSettingsTabsProps } from '../components/EditSettingsTabs/types';

export type EditSettingsTabsModalProps = EditSettingsTabsProps &
	Pick<
		OverlayModalComponentProps<typeof configurationsPiletModals.editSettingsTabs>,
		'completeInteraction' | 'cancelInteraction'
	> & {
		piral: PiletApi;
	};

const LazyEditSettingsTabsModal = React.lazy(
	() => import('../components/EditSettingsTabs/Modal')
);

export const EditSettingsTabsModal: React.FC<EditSettingsTabsModalProps> = props => {
	return (
		<React.Suspense fallback={<div data-testid="loading-edit-settings-tabs" />}>
			<LazyEditSettingsTabsModal {...props} />
		</React.Suspense>
	);
};
